import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-alert-500 text-white" data-id="element-134" data-mp="3cumumz2mo5dq">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2.5 text-center" data-id="element-135" data-mp="3ctbrn1h0b1no">
        <AlertTriangleIcon className="hidden h-4 w-4 shrink-0 sm:block" aria-hidden="true" data-id="element-136" data-mp="32x0d04ty1zq2" />
        <p className="text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-137" data-mp="32zcp41d0tfv7">
          ¡OFERTA POR TIEMPO LIMITADO! Quedan menos de{' '}
          <span className="underline decoration-white/50 underline-offset-2" data-id="element-138" data-mp="2u4eumpu85v1r">100 accesos</span> con
          el 80% de descuento y los 5 bonos incluidos.
        </p>
      </div>
    </div>;
}